import React from 'react';
import AiMagicWandIcon from 'components/general/ai_magic_wand_icon/ai_magic_wand_icon';

const styles = require('./extraction_modal.module.scss');

interface ExtractionModalProps {
  isOpen: boolean;
}

export default function ExtractionModal({ isOpen }: ExtractionModalProps) {
  if (!isOpen) {
    return null;
  }

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.iconContainer}>
          <AiMagicWandIcon className={styles.icon} width="60" height="60" fill="#A729D2" />
        </div>
        <h2 className={styles.title}>Analyzing job information...</h2>
        <p className={styles.description}>
          Relevant details will be used to fill in the job post. You can review and complete the missing fields once extraction is complete.
        </p>
        <div className={styles.spinnerContainer}>
          <div className={styles.spinner} />
        </div>
      </div>
    </div>
  );
}
